/**
 * Created by Thomas Mark
 * Date: 2021-04-02
 * 
 * Hier findet der Benutzer weitere nützliche Funktionen der App. Dieses sind folgende:
 * 
 * - Feedback senden 
 * - Tutorial anzeigen
 * - ReleaseNotes anzeigen
 * - Impressum anzeigen
 *  
 * Sämtliche Einstellungen, die in diesem Dialog angezeigt und verwaltet werden, werden auf
 * dem Server in der 'settings.json'-Datei für jeden Katalog/Container separat gespeichert.
 * 
 * Der Dialog arbeitet in den zwei nachfolgend beschriebenen Modi: 
 * 
 * - ADMIN-Modus - 
 * Ist der Benutzer ein Administrator, dann werden die Daten der draft-Version direkt über das API 
 * vom Server geladen. Diese geschieht bereits im PortfoliosController. Die draft-Daten stehen dann  
 * im REDUX-Store in dem Objekt 'settingList' zur Verfügung. Über den Edit-Button neben der Überschrift 
 * eines Bereiches kann der Administrator die Dialoge 'ReleaseNotesModal' und 'MoreModal' öffnen, um die 
 * entsprechenden Einstellungen eines Bereiches zu verändern.   
 * 
 * - USER-Modus - 
 * Startet ein normaler Benutzer diesen Dialog, so werden die aktuellen Daten der Live-Version angezeigt.
 * Diese werden aus dem lokalen Speicher (IndexedDB) im PortfolioController geladen und in den REDUX-Store
 * in das Objekt 'settingList' übernommen.
 * 
 */
import React from 'react';
import { Redirect } from 'react-router-dom';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Button from '@material-ui/core/Button';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Markdown from 'markdown-to-jsx';
import * as appActions from "../../../store/actions/appActions";
import * as settingActions from "../../../store/actions/settingActions";
import * as cordova from "../../../basics/cordova";
import Footer from "../../partials/Footer";
import Header from "../../partials/Header";
import MediaModal from "../portfolios/MediaModal";

import MoreModal from "./MoreModal";
import WebsiteModal from "../sites/WebsiteModal";
import ReleaseNotesModal from "./ReleaseNotesModal";
import DownloadConfirmModal from "../containers/DownloadConfirmModal";

class MoreController extends React.Component {
    constructor(props) {
        super(props);

        this.component = 'MoreController'

        this.debug = false;

        this.state = {
            sendText: '',
            panel: 'panel2'
        }
    }

    // ==========================================================================
    //
    // LIFESYCLE - SECTION
    //
    // ==========================================================================

    componentDidMount = () => {
        const debug = false;

        debug && console.log(`\n\n##################################################`);
        debug && console.log(`${this.component}:Mount`);
        debug && console.log(`##################################################\n\n`);
    }

    componentWillUnmount = () => {
        const debug = false;

        debug && console.log(`\n\n##################################################`);
        debug && console.log(`${this.component}:Unmount`);
        debug && console.log(`##################################################\n\n`);
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================

    render() {
        const { windowWidth, inputHeight, orientation, appModus, currentContainer, appPreview } = this.props.app;
        const { settingList } = this.props.setting;
        const { loginUser } = this.props.user;

        /**
         * Wenn der Administrator aus dem Edit-Mode in den Preview-Mode
         * wechselt, muss er bestätigen, dass er die draft-Version landen 
         * möchte. Die Funktion onDownloadSuccess() wird nun aufgerufen,  
         * wenn der Administrator das Laden bestätigt hat.
         */
        const onDownloadSuccess = () => {
            if (!appPreview) {
                this.props.setPath('');
                this.props.setAppPreview(!appPreview);
            }
        }

        const onAccordionChange = (panel) => {
            this.setState({ panel })
        }

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================

        const renderFeedback = () => {
            if (!settingList['feedback']) return null;

            const onEdit = () => {
                if (appModus !== 'Admin') return;

                const dialogDetails = {
                    title: "Feedback",
                    groups: [],
                    fields: [
                        {
                            id: "feedback",
                            group: null,
                            widget: "textarea",
                            label: "Einleitung",
                            unitLabel: "",
                            description: "",
                            placeholder: "Feedback Einleitung",
                            disabled: false,
                            value: settingList.feedback.text,
                            rows: 5,
                            validation: "",
                            validationState: null,
                            validationMessage: null,
                        },
                        {
                            id: "email",
                            group: null,
                            widget: "text",
                            label: "E-Mail Adresse",
                            unitLabel: "",
                            description: "",
                            placeholder: "",
                            disabled: false,
                            value: settingList.feedback.email,
                            rows: 0,
                            validation: "",
                            validationState: null,
                            validationMessage: null,
                        }
                    ]
                }

                this.props.setModalDialog('MoreModal', 'Feedback', dialogDetails); // appActions.js
            }

            const renderFeedbackTitle = () => {
                if (!settingList['feedback']['title']) return null;

                return (<span>{settingList.feedback.title} {(appModus === 'Admin') ? <span>&nbsp;&#9998;</span> : <></>}</span>);
            }

            const renderFeedbackText = () => {
                if (!settingList['feedback']['text']) return null;

                const text = settingList.feedback.text.replaceAll('\n', '<br>')

                return (<Markdown>{text}</Markdown>);
            }

            const renderSend = () => {
                const onChangeText = (e) => {
                    this.setState({ sendText: e.target.value });
                }

                const onKeyDown = (e) => {
                    if (e.keyCode === 13) {
                        e.target.blur();
                    }
                }

                const onBlur = (e) => {
                    e.target.blur();
                }

                const onSend = (e) => {
                    cordova.sendFeedback(this.state.sendText, settingList.feedback.email);
                    this.setState({ sendText: "" });
                }

                return (
                    <>
                        <textarea className="w-full bg-white text-black text-normal p-1 rounded focus:outline-none"
                            rows='24' cols='100' name="text" value={this.state.sendText}
                            onChange={onChangeText} onKeyDown={onKeyDown} onBlur={onBlur} />
                        <div className="w-full flex flex-row-reverse text-center items-center text-2xl pt-4">
                            <Button onClick={onSend} variant="contained" color="primary">Senden</Button>
                        </div>
                    </>
                )
            }

            return (
                <div className={"flex w-full flex-col p-2"}>
                    <div className={"text-2xl font-bold"} onClick={onEdit}>{renderFeedbackTitle()}</div>
                    <div onClick={onEdit}>{renderFeedbackText()}</div>
                    {renderSend()}
                </div>
            )
        }

        const renderImpressum = () => {
            if (!settingList['impressum']) return null;

            const onEdit = () => {
                if (appModus !== 'Admin') return;

                const dialogDetails = {
                    title: "Impressum",
                    groups: [],
                    fields: [
                        {
                            id: "impressum",
                            group: null,
                            widget: "textarea",
                            label: "",
                            unitLabel: "",
                            description: "",
                            placeholder: null,
                            disabled: false,
                            value: settingList.impressum.text,
                            rows: 20,
                            validation: "",
                            validationState: null,
                            validationMessage: null,
                        }
                    ]
                }

                this.props.setModalDialog('MoreModal', 'Impressum', dialogDetails); // appActions.js
            }

            const renderTitle = () => {
                if (!settingList['impressum']['title']) return null;

                return (<span>{settingList.impressum.title} {(appModus === 'Admin') ? <span>&nbsp;&#9998;</span> : <></>}</span>);
            }

            const renderText = () => {
                if (!settingList['impressum']['text']) return null;

                const text = settingList.impressum.text.replaceAll('\n', '<br>')

                return (<Markdown>{text}</Markdown>);
            }

            return (
                <Accordion expanded={this.state.panel === 'panel3'} onChange={() => onAccordionChange('panel3')}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel3a-content" id="panel3a-header">
                        <div className={"text-2xl font-bold"} onClick={onEdit}>{renderTitle()}</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div onClick={onEdit}>{renderText()}</div>
                    </AccordionDetails>
                </Accordion>
            )
        }

        const renderReleaseNotes = () => {
            if (!settingList['releaseNotes']) return null;

            const onEdit = () => {
                if (appModus === 'Admin') {
                    this.props.setModalDialog('ReleaseNotesModal', ''); // appActions.js
                }
            }

            const renderHeadline = () => {
                if (!settingList['releaseNotes']['headline']) return null;

                return (<span>{settingList.releaseNotes.headline} {(appModus === 'Admin') ? <span>&nbsp;&#9998;</span> : <></>}</span>);
            }

            const renderIntroduction = () => {
                if (!settingList['releaseNotes']['introduction']) return null;

                return settingList.releaseNotes.introduction;
            }

            const renderNotes = () => {
                if (!settingList['releaseNotes']['notes']) return null;

                return (
                    <ol className='w-full'>
                        {settingList.releaseNotes.notes.map((d, i) => <li key={i}>- {d.topic}</li>)}
                    </ol>
                )
            }

            const renderTimestamp = () => {
                if (!settingList['releaseNotes']['timestamp']) return null;

                return (<span>Erstellt am: {settingList.releaseNotes.timestamp}</span>)
            }

            return (
                <Accordion expanded={this.state.panel === 'panel2'} onChange={() => onAccordionChange('panel2')}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                        <div onClick={onEdit} className={"text-2xl font-bold"}>{renderHeadline()}</div>
                    </AccordionSummary>
                    <AccordionDetails onClick={onEdit}>
                        {renderIntroduction()}
                    </AccordionDetails>
                    <AccordionDetails onClick={onEdit}>
                        {renderNotes()}
                    </AccordionDetails>
                    <AccordionDetails onClick={onEdit}>
                        {renderTimestamp()}
                    </AccordionDetails>
                </Accordion>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================

        if (currentContainer === '') {
            console.log(this.component + ': !currentContainer -> redirect to /\n\n`');
            return <Redirect to='/' />
        }

        if (settingList === null) {
            console.log(this.component + ': !settingList -> redirect to /\n\n`');
            return <Redirect to='/' />
        }

        if (appModus === 'Admin' && !loginUser) {
            console.log(this.component + ': !loginUser -> redirect to /\n\n`');
            return <Redirect to='/' />
        }

        const style = {
            height: inputHeight + 'px',
            minHeight: inputHeight + 'px'
        }

        const styleInner = {
            width: (orientation === 'landscape' ? windowWidth * .5 : windowWidth) + 'px',
            minWidth: (orientation === 'landscape' ? windowWidth * .5 : windowWidth) + 'px',
            height: (orientation === 'landscape' ? inputHeight : inputHeight * .5) + 'px',
            minHeight: (orientation === 'landscape' ? inputHeight : inputHeight * .5) + 'px'
        }

        return (
            <div className={"MoreController w-full h-full flex flex-col"}>
                <Header />
                <div className={"w-full flex bg-gray-300 " + ((orientation === 'landscape') ? '' : 'flex-col')} style={style} >
                    <div className={"flex p-4"} style={styleInner}>
                        {renderFeedback()}
                    </div>
                    <div className={"flex p-2 bg-gray-200 overflow-y-scroll"} style={styleInner}>
                        <div className={"flex w-full flex-col"}>
                            {renderReleaseNotes()}
                            {renderImpressum()}
                        </div>
                    </div>
                </div>
                <MoreModal />
                <WebsiteModal />
                <MediaModal />
                <ReleaseNotesModal />
                <DownloadConfirmModal onSuccess={onDownloadSuccess} />
                <Footer />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        user: state.user,
        setting: state.setting,
        portfolio: state.portfolio,
        sync: state.sync
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, settingActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MoreController);